import { Button, Select } from '@cue/atoms';
import { useObserver, useResponsive } from '@cue/hooks';
import { LocalStorageUtil } from '@cue/utility';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

type SelectOnsite = {
  value: string;
  label: string;
};
type OnSiteNotificationProps = {
  onSelect?: (value?: SelectOnsite) => void;
  onDimensionChange?: (height: number) => void;
};
export const OnSiteNotification: React.FC<OnSiteNotificationProps> = (props) => {
  const { onDimensionChange, onSelect } = props;
  const { t } = useTranslation();
  const notificationRef = useRef<HTMLDivElement>(null);
  const { isMobile } = useResponsive(notificationRef);
  const { height, remove: removeObserver } = useObserver(notificationRef);
  const [onSiteModeSet, setOnsiteModeSet] = useState(LocalStorageUtil.get('onSiteMode') !== null);

  const selectOptions: SelectOnsite[] = [
    {
      label: t('onsite.notification.digital'),
      value: 'false',
    },
    {
      label: t('onsite.notification.onsite'),
      value: 'true',
    },
  ];

  useEffect(() => {
    setOnsiteModeSet(LocalStorageUtil.get('onSiteMode') !== null);
    return () => {
      {
        removeObserver();
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    onDimensionChange && onDimensionChange(!onSiteModeSet ? height : 0);
  }, [height, onDimensionChange, onSiteModeSet]);

  const [selectedTag, setSelectedTag] = useState<SelectOnsite>(
    isMobile ? selectOptions[1] : selectOptions[0],
  );

  useEffect(() => {
    setSelectedTag(isMobile ? selectOptions[1] : selectOptions[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);

  const onChangeOnSite = useCallback((e: SelectOnsite) => {
    setSelectedTag(e);
  }, []);
  const updateOnsiteMode = () => {
    const val = selectedTag.value === 'true';

    setOnsiteModeSet(true);
    LocalStorageUtil.set('onSiteMode', val);
    onSelect && onSelect(selectedTag);
  };
  useEffect(() => {
    if (onSiteModeSet) {
      removeObserver();
    }
  }, [onSiteModeSet, removeObserver]);

  return (
    <div className="cue-onsite-notification" ref={notificationRef}>
      {!onSiteModeSet ? (
        <div>
          <div className="cue-onsite-notification-description">
            {t('onsite.notification.headline')}
            <br />
            {t('onsite.notification.content')}
          </div>
          <div className="cue-onsite-notification-select">
            <Select
              label=""
              dropdownIcon="arrowDown"
              styling={'small'}
              options={selectOptions}
              value={selectedTag}
              onChange={(newValue) => onChangeOnSite(newValue as SelectOnsite)}></Select>
          </div>
          <div className="cue-onsite-notification-confirm">
            <Button onClick={() => updateOnsiteMode()}>{t('onsite.notification.confirm')}</Button>
          </div>
          <div className="cue-onsite-notification-close">
            <Button
              styling="iconOnly"
              icon="close"
              onClick={() => {
                setOnsiteModeSet(true);
                onSelect && onSelect();
              }}>
              Close
            </Button>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
